(function () {
  'use strict';

  // Recompute every minute so the message flips automatically when the 14:00
  // cutoff passes while a visitor has the page open.
  var RECHECK_MS = 60 * 1000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getLogic() {
    return window.AumaerkLieferungLogic || null;
  }

  function cutoffLabel(L) {
    var h = L.CUTOFF_HOUR;
    var m = L.CUTOFF_MINUTE;
    return (h < 10 ? '0' + h : '' + h) + ':' + (m < 10 ? '0' + m : '' + m);
  }

  // next-day available  <=>  earliestDelivery(now) === tomorrow.
  // earliestDelivery() already encodes the cutoff, the Mon-Thu next-day prep,
  // the Tue-Fri delivery window AND holiday/blackout roll-forward — so this
  // single comparison is true ONLY when ordering now lands delivery tomorrow.
  function computeState(L, rawBlackouts) {
    var now = new Date();
    var blackouts = L.buildBlackouts(rawBlackouts, now);
    var earliest = L.earliestDelivery(now, blackouts);
    var tomorrow = L.addDays(L.viennaCalendarDate(now), 1);
    return {
      isNextDay: L.toISODate(earliest) === L.toISODate(tomorrow),
      earliest: earliest
    };
  }

  function formatDate(L, date) {
    var fn = L.formatDisplayFull || L.formatDisplayLong;
    return fn(date);
  }

  function render(root, L) {
    var textEl = root.querySelector('[data-delivery-promise-text]');
    if (!textEl) return;
    var raw = root.getAttribute('data-delivery-promise-blackouts') || '';
    var state = computeState(L, raw);

    root.classList.remove('delivery-promise--next-day', 'delivery-promise--fallback');
    if (state.isNextDay) {
      textEl.textContent = '🚚 Bis ' + cutoffLabel(L) + ' Uhr bestellen, schon morgen genießen.';
      root.classList.add('delivery-promise--next-day');
    } else {
      textEl.textContent = 'Lieferung voraussichtlich am ' + formatDate(L, state.earliest);
      root.classList.add('delivery-promise--fallback');
    }
    root.removeAttribute('hidden');
  }

  function renderAll() {
    var L = getLogic();
    if (!L) return false;
    var roots = document.querySelectorAll('[data-delivery-promise]');
    for (var i = 0; i < roots.length; i++) render(roots[i], L);
    return true;
  }

  function boot() {
    if (renderAll()) return;
    // lieferung-logic.js is `defer` too; if it hasn't executed yet, poll
    // briefly until the module appears (cap ~2s), then give up — leaving the
    // banner hidden rather than showing wrong info.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (renderAll() || tries > 40) clearInterval(iv);
    }, 50);
  }

  ready(boot);

  // Flip the message when the cutoff passes mid-session.
  setInterval(renderAll, RECHECK_MS);

  // The cart drawer swaps its DOM in on open/refresh, re-inserting a fresh
  // (hidden) banner — re-render on the theme's cart event...
  document.addEventListener('cart:refresh', renderAll);

  // ...and as a fallback, watch for drawer swaps that don't fire that event.
  if (typeof MutationObserver === 'function' && document.body) {
    var pending = false;
    var mo = new MutationObserver(function () {
      var roots = document.querySelectorAll('[data-delivery-promise]');
      var needs = false;
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].hasAttribute('hidden')) { needs = true; break; }
      }
      if (needs && !pending) {
        pending = true;
        requestAnimationFrame(function () { pending = false; renderAll(); });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
